import { render } from "./CombatSimulator.vue?vue&type=template&id=439f964e"
import script from "./CombatSimulator.vue?vue&type=script&lang=js"
export * from "./CombatSimulator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/area/CombatSimulator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "439f964e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('439f964e', __exports__)) {
    api.reload('439f964e', __exports__)
  }
  
  module.hot.accept("./CombatSimulator.vue?vue&type=template&id=439f964e", () => {
    api.rerender('439f964e', render)
  })

}


export default __exports__